import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { FadeScrollWrapper, ICONS } from '@app/styles';
import { ModuleFE_RuntimeSmartDoc } from '@app/advisor-frontend';
import { compare } from '@nu-art/ts-common';
import { Renderer_SmartLog } from '../Renderer_SmartLog/Renderer_SmartLog.js';
import { Renderer_QuickNote } from '../Renderer_QuickNote/Renderer_QuickNote.js';
import './Renderer_SmartLogs.scss';
export class Renderer_SmartLogs extends ComponentSync {
    //######################### Life Cycle #########################
    __onRuntimeSmartDocsUpdated = (...params) => {
        const logs = ModuleFE_RuntimeSmartDoc.getAllNotes();
        if (logs.length !== this.state.logs.length || !compare(logs, this.state.logs))
            this.setState({ logs });
    };
    deriveStateFromProps(nextProps, state) {
        state.quickNote ??= false;
        state.logs ??= ModuleFE_RuntimeSmartDoc.getAllNotes();
        return state;
    }
    //######################### Logic #########################
    openQuickNote = () => {
        this.setState({ quickNote: true });
    };
    //######################### Render #########################
    render() {
        if (this.state.quickNote || this.state.editNoteMode)
            return this.render_EditNote();
        return this.render_Logs();
    }
    render_Logs = () => {
        return _jsxs(FadeScrollWrapper, { className: 'component__smart-logs__logs', children: [this.state.logs.map(doc => _jsx(Renderer_SmartLog, { smartDoc: doc, toggleEdit: id => this.setState({ editNoteMode: id }) }, doc._id)), _jsx(ICONS.advisor_avn_addNote.component, { className: 'add-log', onClick: this.openQuickNote })] });
    };
    render_EditNote = () => {
        return _jsx(Renderer_QuickNote, { logId: this.state.editNoteMode, onCloseEditor: () => this.setState({ editNoteMode: undefined, quickNote: false }) });
    };
}
//# sourceMappingURL=Renderer_SmartLogs.js.map